<template>

    <div :class="{'-is-visible':isVisible}" class="search-filter-component">
      <div class="contents-backdrop"  @click="onClose" ></div>
        <div class="contents">

            <div class="filter-actions">
                <button type="button" @click="onClose" class="btn btn--white -close-btn"><i class="fal fa-times"></i></button>
                <i class="fal fa-spin fa-spinner filter-activity-indicator"></i>
                <button type="button" @click="onClose" class="btn btn-primary -confirm-btn">{{confirmBtn_Label}}</button>

            </div>


         
         
           
            <combined-filter ref="combinedFilterInstance" :force-hide-content-title="forceHideContentTitle" :filter="filter" :totalCount="totalCount" ></combined-filter>

        </div>
    </div>


</template>


<script src="./SearchFilterComponent.ts" lang="ts"></script>
<style  src="./SearchFilterComponent.css"></style>